import Notifier from '@/modules/notifier';

import { registerDevice } from '@/modules/firebase';

const getRegistration = async () => await navigator.serviceWorker.ready;

const getSubscription = async (registration) => {
  console.log('[ServiceWorker] getSubscription...');

  if (!('PushManager' in window)) {
    console.log('[ServiceWorker] pushManager not supported!');
  }

  try {
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      console.log('[ServiceWorker] getSubscription! (hit)');

      return subscription;
    }

    console.log('[ServiceWorker] getSubscription! (miss)');
  } catch (error) {
    console.log('[ServiceWorker] getSubscription failed', error);

    throw error;
  }
};

const register = async () => {
  console.log('[ServiceWorker] register...');

  if (!('serviceWorker' in navigator)) return console.log('[ServiceWorker] serviceWorker not supported!');

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js');

    console.log('[ServiceWorker] register!');
  } catch (error) {
    console.log('[ServiceWorker] register failed', error);
  }
};

const subscribe = async () => {
  console.log('[ServiceWorker] subscribe...');

  try {
    await registerDevice();

    console.log('[ServiceWorker] subscribe!');
  } catch (error) {
    console.log('[ServiceWorker] subscribe failed', error);
  }
};

export const init = () => {
  register();

  const notifier = new Notifier();

  if (notifier.isGranted()) subscribe();
};

export const unsubscribe = async () => {
  try {
    const registration = await getRegistration();
    const subscription = await getSubscription(registration);

    const result = await subscription.unsubscribe();

    return result;
  } catch (error) {
    console.log('[ServiceWorker] subscribe failed', error);
  }
};
